var exports = {
  "vK": "xcc377c0b--a2c698--banner",
  "kZ": "xcc377c0b--a2c698--image-wrapper",
  "Qq": "xcc377c0b--a2c698--text",
  "s4": "xcc377c0b--a2c698--call-button-wrapper",
};

module.exports = exports;
